import { render, staticRenderFns } from "./InboundEmails.vue?vue&type=template&id=2e4999d0&scoped=true&"
import script from "./InboundEmails.vue?vue&type=script&lang=js&"
export * from "./InboundEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4999d0",
  null
  
)

export default component.exports